import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import Button from 'shared/components/base/button/BaseButton'
import dictionary from 'shared/constants/dictionary'
import {
  useEmit,
  useSocketInstance,
} from 'shared/contexts/socket/socket-context'
import useQuery from 'shared/hooks/useQueyParams'
import { RootState } from 'store/store'

import Ringing from './ringing'
import CallCenterSubmitPhoneCall from './submit-phone-call/callcenter-call-submission'
import SalesPerSonCallSubmission from './submit-phone-call/sales-person-call-submission'
import setSocketListeners, { isFixedUser } from './utils/set-socket-listeners'

const CallDetail = () => {
  const query = useQuery()
  const showPopup = query.get('showPopup') || query.get('show')
  const isSales = query.get('sales')
  const showTestSocketButton = query.get('socket')
  const ringingData = useSelector(
    (state: RootState) => state.callDetail.ringingData
  )
  const showCallRegistration = useSelector(
    (state: RootState) => state.callDetail.showCallRegistration
  )
  const user = useSelector((state: RootState) => state.loggedInUser)
  const socketInstance = useSocketInstance()
  const dispatch = useDispatch()
  const emit = useEmit()
  const [socketReqLoading, setSocketReqLoading] = useState(false)
  const canViewSales =
    user.teamName === 'طراحی محصول' || isSales || isFixedUser(user?.userDomain)

  // functions
  const handleTestSocketButtonClick = () => {
    setSocketReqLoading(true)
    emit('getLeadPreNames')
      .then((res) => {
        console.log('response getLeadPreNames is: ', res)
      })
      .catch(() => {
        toast.error(dictionary.socket_timeout)
      })
      .finally(() => {
        setSocketReqLoading(false)
      })
  }

  // effects
  useEffect(() => {
    if (socketInstance)
      setSocketListeners(socketInstance as any, dispatch, user as any)
  }, [socketInstance, user, dispatch])

  return (
    <>
      {showTestSocketButton && (
        <Button
          loading={socketReqLoading}
          onClick={handleTestSocketButtonClick}
          className="z-[10000] fixed left-[40%] top-8"
        >
          uncle soufilo
        </Button>
      )}
      <Transition.Root show={showCallRegistration || !!showPopup} as={Fragment}>
        <Dialog
          className="fixed z-50 inset-0 overflow-y-auto bg-white"
          onClose={console.log}
        >
          {canViewSales ? (
            <SalesPerSonCallSubmission />
          ) : (
            <CallCenterSubmitPhoneCall />
          )}
        </Dialog>
      </Transition.Root>

      <Ringing
        onHold={() => {
          return
        }}
        invoiceCount={ringingData?.invoiceCount || 0}
        callerName={ringingData?.callerName || 'مشتری جدید'}
        preName={ringingData?.preName}
        phoneNumber={ringingData?.phoneNumber || 'شماره نامشخص'}
      />
    </>
  )
}

export default CallDetail
